import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  getSessionStorage,
  removeSessionStorage,
} from '@/common/sessionStorages';
import { withNoSSR } from '@/components/NoSSR';

const FestivalInviteLinkContainer: FC = withNoSSR(() => {
  const { replace } = useRouter();

  const removeFestivalInviteLinkSession = () => removeSessionStorage('FI1LINK');

  useEffect(() => {
    const festivalInviteLink = getSessionStorage('FI1LINK');
    if (!!festivalInviteLink) {
      removeFestivalInviteLinkSession();
      replace(`/festival/landing?inviteLink=${festivalInviteLink}`);
    }
    return removeFestivalInviteLinkSession;
  }, []);

  return <></>;
});

export default FestivalInviteLinkContainer;
